import { render, staticRenderFns } from "./organizationSettings.vue?vue&type=template&id=86f80400&scoped=true&"
import script from "./organizationSettings.vue?vue&type=script&lang=js&"
export * from "./organizationSettings.vue?vue&type=script&lang=js&"
import style0 from "./organizationSettings.vue?vue&type=style&index=0&id=86f80400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f80400",
  null
  
)

export default component.exports